import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-single-section',
  templateUrl: './blog-single-section.component.html',
  styleUrls: ['./blog-single-section.component.scss']
})
export class BlogSingleSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
